/* BAM site-wide polish v3 - extracted from snippets/bam-polish.liquid 2026-08-26.
   Logic unchanged. Now loaded with defer instead of parsed inline in <head>.
   Injects the trust strip and brand marquee, sets up scroll reveal, tunes images.

   2026-08-26: brand marquee expanded from 10 to 16 entries so it matches the
   Brands dropdown (snippets/bam-brands-dropdown.liquid) exactly - the two lists
   should never disagree about which brands BAM carries. Added District, Hanes,
   ComfortWash by Hanes, Shaka Wear, Sport-Tek and Team 365. Order is by
   prominence, not alphabetical, so the biggest catalogues scroll past first.

   Also: Jerzees, Richardson and Port Authority now point at their real
   collection pages instead of /search?q= URLs. Those collections did not exist
   when this list was written, so search was the only option at the time. All
   16 handles verified against the live collection list.

   NOTE: the track animates translateX(-50%) over a fixed duration set in
   bam-polish.css. More brands means a longer track, so the duration was raised
   there (55s -> 88s desktop, 40s -> 64s mobile) to hold the scroll speed steady.
   If you add or remove brands here, rescale it there too - roughly 5.5s per
   brand on desktop, 4s on mobile. */
(function () {
  /* ===== 1. Trust strip - concrete promises (backed by Wholesale Terms) ===== */
  function injectTrustStrip() {
    if (document.querySelector('.bam-trust-strip')) return;
    var headerGroup = document.querySelector('#header-group') || document.querySelector('header');
    if (!headerGroup) return;
    var html = '\
      <div class="bam-trust-strip" role="region" aria-label="Wholesale benefits">\
        <div class="bam-trust-strip__inner">\
          <span class="bam-trust-strip__item">\
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>\
            No minimum orders\
          </span>\
          <span class="bam-trust-strip__item">\
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>\
            2 business days ship for Get It Fast items\
          </span>\
          <span class="bam-trust-strip__item">\
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>\
            Wholesale pricing for approved members\
          </span>\
        </div>\
      </div>';
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    headerGroup.insertAdjacentElement('afterend', wrap.firstElementChild);
  }

  /* ===== 2. Brand marquee ===== */
  function injectBrandStrip() {
    if (document.querySelector('.bam-brands')) return;
    /* Keep in sync with snippets/bam-brands-dropdown.liquid. */
    var brands = [
      { name: 'BELLA + CANVAS',       url: '/collections/bella-canvas' },
      { name: 'Next Level',           url: '/collections/next-level' },
      { name: 'CORE365',              url: '/collections/core365' },
      { name: 'Gildan',               url: '/collections/gildan-1' },
      { name: 'Comfort Colors',       url: '/collections/comfort-colors' },
      { name: 'Port & Company',       url: '/collections/port-company' },
      { name: 'Port Authority',       url: '/collections/port-authority' },
      { name: 'Sport-Tek',            url: '/collections/sport-tek' },
      { name: 'District',             url: '/collections/district' },
      { name: 'Jerzees',              url: '/collections/jerzees' },
      { name: 'Hanes',                url: '/collections/hanes' },
      { name: 'ComfortWash by Hanes', url: '/collections/comfortwash-by-hanes' },
      { name: 'A4',                   url: '/collections/a4' },
      { name: 'Richardson',           url: '/collections/richardson' },
      { name: 'Shaka Wear',           url: '/collections/shaka-wear' },
      { name: 'Team 365',             url: '/collections/team-365' }
    ];
    var doubled = brands.concat(brands);
    var items = doubled.map(function (b) {
      var label = b.name.replace(/&/g, '&amp;');
      var href  = b.url.replace(/&/g, '&amp;');
      return '<a class="bam-brands__item" href="' + href + '">' + label + '</a>';
    }).join('');
    var html = '\
      <section class="bam-brands" aria-label="Brands we carry">\
        <p class="bam-brands__label">Brands we carry</p>\
        <div class="bam-brands__viewport">\
          <div class="bam-brands__track">' + items + '</div>\
        </div>\
      </section>';
    var trust = document.querySelector('.bam-trust-strip');
    var anchor = trust || document.querySelector('#header-group') || document.querySelector('header');
    if (!anchor) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    anchor.insertAdjacentElement('afterend', wrap.firstElementChild);
  }

  /* ===== 3. Scroll reveal - NEVER targets cards or gallery or qty controls ===== */
  function setupScrollReveal() {
    if (!('IntersectionObserver' in window)) return;
    var selectors = [
      '.shopify-section h1', '.shopify-section h2', '.shopify-section h3',
      '.shopify-section [class*="hero"] p', '.shopify-section [class*="hero"] a',
      '.section__subheading', '.rich-text__heading', '.rich-text__caption',
      '.featured-collection__heading'
    ];
    var skip = 'header, .header, #header-group, .bam-trust-strip, .bam-brands, footer, ' +
               '.product-card, .card-product, .product-grid__item, .collection-product-card, ' +
               '.product-gallery, [class*="product-gallery"], [class*="product-media"], ' +
               'cart-items-component, cart-line-quantity, [class*="quantity"], ' +
               '.product-information, .product-details, .product__info';
    var els = document.querySelectorAll(selectors.join(','));
    var i = 0;
    els.forEach(function (el) {
      if (el.hasAttribute('data-bam-anim')) return;
      if (el.closest(skip)) return;
      el.setAttribute('data-bam-anim', '');
      var delay = (i % 4) * 100;
      if (delay) el.setAttribute('data-bam-anim-delay', String(delay));
      i++;
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    document.querySelectorAll('[data-bam-anim]').forEach(function (el) { io.observe(el); });

    setTimeout(function(){
      document.querySelectorAll('[data-bam-anim]:not(.is-visible)').forEach(function(el){
        el.classList.add('is-visible');
      });
    }, 1200);
  }

  function tuneImages() {
    document.querySelectorAll('img:not([loading])').forEach(function (img) {
      var rect = img.getBoundingClientRect();
      if (rect.top > window.innerHeight * 1.5) {
        img.setAttribute('loading', 'lazy');
      }
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
    });
  }

  function run() {
    injectTrustStrip();
    injectBrandStrip();
    setupScrollReveal();
    tuneImages();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
